import { jsx as _jsx } from "react/jsx-runtime";
import { StarFill, StarHalfFill, StarNoFill } from "../assets";
import styles from "./star-rating.module.css";
export const StarRating = ({ starRating  })=>{
    const stars = [
        ...Array.from({
            length: 5
        }).keys()
    ];
    const starComponents = stars.map((_, index)=>{
        const starNumber = index + 1;
        const idPrefix = `star-${starRating}-${starNumber}`;
        const isFilled = starNumber <= Math.floor(starRating / 2);
        const isHalf = starNumber === Math.ceil(starRating / 2) && starRating % 2 !== 0;
        return isFilled ? /*#__PURE__*/ _jsx(StarFill, {}, starNumber) : isHalf ? /*#__PURE__*/ _jsx(StarHalfFill, {
            idPrefix: idPrefix
        }, starNumber) : /*#__PURE__*/ _jsx(StarNoFill, {}, starNumber);
    });
    return /*#__PURE__*/ _jsx("div", {
        className: styles.starRatingContainer,
        children: starComponents
    });
};
